import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContextBookCardLong from 'rebook/apps/books/components/ContextBookCardLong';
import ContextBookCard from 'rebook/apps/books/components/ContextBookCard';
import EmptyBookCard from 'rebook/apps/books/components/EmptyBookCard';

import styles from './style.scss';


const BookList = ({
  books,
  shouldShowOrder,
  maxColumns,
  isAudio,
  shouldShowAvailable,
  linkCallback,
  handleDelete,
  isDisplayLongVersion,
}) => (
  <div className={styles.bookList}>
    <ul className={styles.items}>
      {books.map((item, i) => {
        let book, order;
        if (item) {
          book = item.book ? item.book : item;
        }

        if (item && shouldShowOrder) {
          order = item.order ? item.order : null;
        }

        return (
          <li
            className={classNames(styles.item,
              { [styles.oneColsLayout]: maxColumns == 1 },
              { [styles.treeColsLayout]: maxColumns == 3 },
              'jest-book-card-item')}
            key={item && item.id ? item.id : i}>
            {item ?
              <React.Fragment>
                {isDisplayLongVersion ?
                  <ContextBookCardLong
                    book={book}
                    order={order}
                    isAudio={isAudio}
                    showDeleteButton={!!handleDelete}
                    handleDelete={(bookInfo) => handleDelete(bookInfo)}
                    linkCallback={linkCallback}
                    shouldShowAvailable={shouldShowAvailable} />
                  :
                  <ContextBookCard
                    book={book}
                    order={order}
                    isAudio={isAudio}
                    showDeleteButton={!!handleDelete}
                    handleDelete={(bookInfo) => handleDelete(bookInfo)}
                    linkCallback={linkCallback}
                    shouldShowAvailable={shouldShowAvailable} />
                }
              </React.Fragment>
              : <EmptyBookCard />
            }
          </li>
        );
      })}
    </ul>
  </div>
);

BookList.propTypes = {
  books: PropTypes.array.isRequired,
  shouldShowOrder: PropTypes.bool,
  maxColumns: PropTypes.number,
  isAudio: PropTypes.bool,
  handleDelete: PropTypes.func,
};

BookList.defaultProps = {
  shouldShowOrder: true,
  maxColumns: 4,
  isAudio: false,
};

export default BookList;
